import { Icon, SvgSearch, TextInput, Tooltip } from '@loomhq/lens';
import cn from 'classnames';
import Mousetrap from 'mousetrap';
import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import { openModal } from 'actions/modals';
import { DESTINATION_SEARCH_MODAL } from 'constants/modalTypes';
import { MOD_K } from 'constants/mousetrap';
import { isLinux, isMac, isWindows } from 'utilities/device';

import {
  SEARCHBAR_MAC_TOOLTIP,
  SEARCHBAR_WIN_TOOLTIP,
  TAGLINE,
} from '../constants';

import styles from './styles.module.less';

export const tooltipContent = () => {
  if (isMac) {
    return SEARCHBAR_MAC_TOOLTIP;
  } else if (isWindows) {
    return SEARCHBAR_WIN_TOOLTIP;
  } else if (isLinux) {
    return SEARCHBAR_WIN_TOOLTIP;
  }

  return '';
};

export default function SearchBar() {
  const dispatch = useDispatch();
  const ref = useRef(null);

  function openSearch(isShortcut) {
    const rect = ref.current.getBoundingClientRect();

    dispatch(
      openModal(DESTINATION_SEARCH_MODAL, {
        inputLeft: rect.x,
        inputWidth: rect.width,
        isShortcut: Boolean(isShortcut),
      })
    );
  }

  useEffect(() => {
    Mousetrap.bind(MOD_K, event => {
      event.preventDefault();
      openSearch(true);
    });

    return () => {
      Mousetrap.unbind(MOD_K);
    };
  });

  return (
    <Tooltip
      content={tooltipContent()}
      placement="bottomCenter"
      isInline={false}
    >
      <div
        className={cn(styles.searchBar)}
        id="intercom-destination-search-bar"
      >
        <TextInput
          placeholder={TAGLINE}
          icon={<Icon icon={<SvgSearch />} size="3" color="grey6" />}
          onClick={openSearch}
          size="medium"
          ref={ref}
          onFocus={() => ref.current.blur()}
          tabIndex={0}
        />
      </div>
    </Tooltip>
  );
}
